var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"s-marquee"},[_c('span',{staticClass:"marquee"},[_vm._v(_vm._s(_vm.marquee)+" "+_vm._s(_vm.marquee))])])}
var staticRenderFns = []

export { render, staticRenderFns }